import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ViewIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M23 12.4h-.1a4.1 4.1 0 0 1-.1.3 13.5 13.5 0 0 1-2.4 3.5A11.3 11.3 0 0 1 12 20c-3.9 0-6.6-2-8.4-3.8a15.4 15.4 0 0 1-2.5-3.8 1 1 0 0 1 0-.8 5 5 0 0 1 .1-.3 13.4 13.4 0 0 1 2.4-3.5C5.4 6 8.1 4 12 4c3.9 0 6.6 2 8.4 3.8a15.4 15.4 0 0 1 2.5 3.8c.1.3.1.5 0 .8Zm-19.6.2a12 12 0 0 1-.3-.6 12 12 0 0 1 2-2.8A9.3 9.3 0 0 1 12 6c3.1 0 5.4 1.6 6.9 3.2a13.4 13.4 0 0 1 2 2.8 11.9 11.9 0 0 1-2 2.8A9.3 9.3 0 0 1 12 18a9.3 9.3 0 0 1-6.9-3.2l-1.7-2.2Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default ViewIcon;
